<template>
  <div :class="col!=='Done' ? 'container1': 'container2'">
     <h2>{{ sectionTitle }}</h2>
    <NewTask v-if="col !== 'Done'" :col="col"/>
     <div class="container-tasks" :class="col==='Done' ? 'done': ''" v-for="(task, index) in tasks" :key="task.id">
        <div v-if="!task.isEditing">
            <button :class="col==='Done' ? 'done-icons': ''" class="icons" @click="handleCheck(task, task.collection)"><Icon icon="ic:round-done" /></button>
            {{task.title}}
        </div>

        <form class="task-form" @submit.prevent="handleEdit(task, index)" v-if="task.isEditing">
            <input class="newtask-input" type="text" v-model="editedTask[index]">
            <button class="icons" id="edit-task"><Icon icon="mdi:pencil-outline" /></button>    
        </form>
    
        <div class="container-buttons" v-if="!task.isEditing">
            <button :class="col==='Done' ? 'done-icons': ''" class="icons" @click="beginEdit(task, index)"><Icon icon="mdi:pencil-outline" /></button>
            <button :class="col==='Done' ? 'done-icons': ''" v-if="col !== 'Standby'" class="icons" @click="handleMove(task, 'Standby')"><Icon icon="ic:outline-watch-later" /></button>
            <button :class="col==='Done' ? 'done-icons': ''" v-if="col !== 'ToDo'" class="icons" @click="handleMove(task, 'ToDo')"><Icon icon="ic:outline-format-list-bulleted" /></button>
            <button :class="col==='Done' ? 'done-icons': ''" class="icons" @click="handleDelete(task)"><Icon icon="mdi:trash-can-outline" /></button>   
        </div>
     </div>
  </div>
  
</template>

<script>
import NewTask from './NewTask'
import getCollection from '../composables/getCollection'
import deleteTask from '../composables/deleteTask'
import addTask from '../composables/addTask'
import { Icon } from '@iconify/vue'
import getUser from '../composables/getUser'
import { ref } from '@vue/reactivity'

//firebase imports
import { db } from '../firebase/config'
import { updateDoc, doc } from 'firebase/firestore'

export default {
    
    components: { NewTask, Icon },
    props: [ 'sectionTitle', 'col' ],
    setup(props){
        const { user } = getUser()
        
        //Fetches collection from firebase
        const { documents: tasks } = getCollection(
            props.col,
            ['userUid', '==', user.value.uid ]
        )
        
        //Deletest a task
        const handleDelete = (task) => {
           deleteTask(task, props.col)
        }

        //Moves a task to another collection
        const handleMove = async (task, targetCol) => {
            deleteTask(task, props.col)      
            addTask(task, targetCol) 
        }

        //Checks off an item as done and moves it to the done collection. If it is in the done collection, it is moved back to the original collection
        const handleCheck = async (task, targetCol) => {
            deleteTask(task, props.col)

            if(props.col !== 'Done'){
                const newTargetCol = 'Done'
                addTask(task, newTargetCol)

            } else {
                addTask(task, targetCol)
            }
        }
        
        //Initiates edited task variable
        const editedTask = ref([])
        
        //Begins editing a task, keeping track of original task
        const beginEdit = (task, index) =>
        { 
            task.isEditing = true
            editedTask.value[index] = task.title
        }
        
        //Edits task and updates task in firebase
        const handleEdit = async (task, index) => {
                const docRef = doc(db, props.col, task.id )
                await updateDoc(docRef, {
                    title: editedTask.value[index]
                })    
            task.isEditing = false
        }

        return { tasks, handleDelete, handleMove, handleCheck, handleEdit, editedTask, beginEdit }
    }
}
</script>

<style>

</style>